import { useState } from 'react';
import { Field, useToast } from '../components/ui';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { ROLE_HELP, ROLE_LABEL } from '../lib/types';

export function AccountPage() {
  const { user } = useAuth();
  const toast = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [busy, setBusy] = useState(false);

  if (!user) return null;

  const mismatch = repeat.length > 0 && next !== repeat;

  const save = async () => {
    setBusy(true);
    try {
      await api.changePassword(current, next);
      toast.push('Password changed');
      setCurrent(''); setNext(''); setRepeat('');
    } catch (e) {
      toast.push((e as Error).message, true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 560 }}>
      <h1 className="title" style={{ marginBottom: 18 }}>Your account</h1>

      <div className="panel">
        <div className="row" style={{ gap: 14 }}>
          <span className="avatar big">{(user.name || user.username).slice(0, 1).toUpperCase()}</span>
          <div>
            <div style={{ fontWeight: 600 }}>{user.name}</div>
            <div className="sub">@{user.username} · {ROLE_LABEL[user.role]} — {ROLE_HELP[user.role]}</div>
          </div>
        </div>
      </div>

      <div className="panel">
        <h2 className="section">Change password</h2>
        <Field label="Current password" type="password" value={current} onChange={setCurrent} />
        <Field label="New password" type="password" value={next} onChange={setNext} hint="At least 8 characters" />
        <Field label="Repeat new password" type="password" value={repeat} onChange={setRepeat} hint={mismatch ? 'The two passwords are different' : undefined} />
        <div className="row end">
          <button className="btn primary" disabled={busy || !current || next.length < 8 || next !== repeat} onClick={() => void save()}>
            Change password
          </button>
        </div>
      </div>
    </div>
  );
}
